/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import { useIntl } from 'react-intl';
import { Typography } from 'antd';

export type qaType = {
  qaTitle?: string;
  qaSubTitle?: string;
  // true = vendor/share side, false = project side
  isShareSide?: boolean;
};

const QuestionsAnswerUpperBlock: React.FC<qaType> = ({
  qaTitle,
  qaSubTitle,
  isShareSide = false,
}) => {
  const intl = useIntl();
  const styles = useStyles(styleFn);

  const subtitleId = isShareSide
    ? 'sub-title-questions-share'
    : 'sub-title-questions-project';

  return (
    <div
      css={{
        ...styles.qaContainer,
        justifyContent: isShareSide ? 'center' : 'flex-start',
      }}>
      <div css={styles.qaLeftContainer}>
        <Typography css={styles.headerTitle}>
          {qaTitle || intl.formatMessage({ id: 'title-questions' })}
        </Typography>
        <Typography css={styles.headerSubTitle}>
          {qaSubTitle || intl.formatMessage({ id: subtitleId })}
        </Typography>
      </div>
      <div css={styles.qaRightContainer}></div>
    </div>
  );
};

export default QuestionsAnswerUpperBlock;

export const styleFn: ThemedStyleFn = (theme) => ({
  qaContainer: {
    display: 'flex',
    justifyItems: 'space-between',
    width: '100%',
  },
  qaLeftContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: 800,
  },
  headerSubTitle: {
    color: 'grey',
    whiteSpace: 'pre-wrap',
    width: '100%',
  },
  qaRightContainer: {},
});
